<script setup>
import { useChecklist } from '@/composables/useChecklist'
import { useAbility } from '@casl/vue'
import { useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Checklist',
  },
})

const router = useRouter()
const ability = useAbility()
const { templates, loading, fetchTemplates } = useChecklist()

onMounted(fetchTemplates)

const headers = [
  { title: 'Nama', key: 'name' },
  { title: 'Kategori', key: 'category' },
  { title: 'Jumlah Item', key: 'items' },
  { title: 'Status', key: 'is_active', width: 110 },
  { title: 'Aksi', key: 'actions', align: 'center', sortable: false, width: 160 },
]
</script>

<template>
  <div>
    <VRow class="mb-4">
      <VCol cols="12">
        <div class="d-flex align-center justify-space-between flex-wrap gap-3">
          <div>
            <h4 class="text-h4 font-weight-bold">
              Template Checklist
            </h4>
            <p class="text-body-2 text-medium-emphasis mb-0">
              Checklist berulang (APAR, Kebersihan, MFK, Hand Hygiene, dst. — §10.3)
            </p>
          </div>
          <VBtn
            v-if="ability.can('template-manage', 'Checklist')"
            prepend-icon="ri-add-line"
            @click="router.push({ name: 'checklist-templates-create' })"
          >
            Tambah Template
          </VBtn>
        </div>
      </VCol>
    </VRow>

    <VCard>
      <VDataTable
        :headers="headers"
        :items="templates"
        :loading="loading"
        hide-default-footer
        :items-per-page="-1"
      >
        <template #item.category="{ item }">
          {{ item.category?.name ?? '-' }}
        </template>
        <template #item.items="{ item }">
          {{ item.items_count ?? '-' }}
        </template>
        <template #item.is_active="{ item }">
          <VChip
            size="small"
            :color="item.is_active ? 'success' : 'secondary'"
          >
            {{ item.is_active ? 'Aktif' : 'Nonaktif' }}
          </VChip>
        </template>
        <template #item.actions="{ item }">
          <VBtn
            v-if="ability.can('fill', 'Checklist')"
            size="small"
            variant="text"
            color="primary"
            prepend-icon="ri-edit-2-line"
            @click="router.push({ name: 'checklist-fill-template-id', params: { templateId: item.id } })"
          >
            Isi
          </VBtn>
          <VBtn
            v-if="ability.can('template-manage', 'Checklist')"
            icon="ri-settings-4-line"
            variant="text"
            size="small"
            @click="router.push({ name: 'checklist-templates-id-edit', params: { id: item.id } })"
          />
        </template>
        <template #no-data>
          <div class="text-center py-10">
            <p class="text-medium-emphasis">
              Belum ada template checklist.
            </p>
          </div>
        </template>
      </VDataTable>
    </VCard>
  </div>
</template>
